import React, {  } from 'react';
import { DocumentationRoutes } from "../../toolympus/components/Documentation";
import { ProjectDocumentationEditor } from './ProjectDocumentationEditor';
import { MediaLibProviderX } from './MediaLibProviderX';



export const Documentation = () => {
  return (
    <MediaLibProviderX>
      <DocumentationRoutes
          apiPath="/api/documentation"
          rootSlug="root"
          defaultRootPageTitle="Документация"
          enableCustomFieldsBlock
          editor={ProjectDocumentationEditor}
          />
    </MediaLibProviderX>
  );
}



